<template src="./template/index.html">
</template>
<script>
import {getThankYouPageData} from '@/services/services.js'
import DibbleAPI from '@/api.js'
import DibbleJS from "@/dibble";
export default {
    data () {
        return {
            dataThankYou: {

            }
        }
    },
    methods: {
        getThankYouPageData,
        firstLoadThankYouPage () {
            this.getThankYouPageData()
                .then(res => {
                    if (DibbleAPI.isResponseSuccess(res.data)) {
                        this.dataThankYou = res.data
                    }
                })
        },
        goToTheHomePage () {
            this.$router.push(`/welcome/${DibbleJS.getUID()}`)
        }
    },
    mounted () {
        this.firstLoadThankYouPage()
    }
}
</script>
<style scoped>

</style>